/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getMessages.defs.js'
export { main as default } from './getMessages.defs.js'
